/*  MUI  */
import { Box, Checkbox, FormControlLabel } from '@mui/material';

/*  Shared  */
import { SentenceCase } from 'application/Shared/Components/Text';
import { TooltipQ } from 'application/Shared/Components/Tooltips';
import { FontSizes } from 'application/Shared/Constants';

/* NPM */
import { cloneDeep } from 'lodash';

/*  React  */
import React from 'react';
import { useTranslation } from 'react-i18next';

/* Internal Components */
import { useManagedTableV2Context } from '../ManagedTableV2ContextProvider';

export const ManagedTableTogglesV2 = ({ disabled }) => {
    const { t } = useTranslation();
    const { setSearchText, setToggles, table, tableName, toggles } =
        useManagedTableV2Context();

    const handleToggleChange = ({ key, checked }) => {
        const currentToggles = cloneDeep(toggles);

        const toggle = { ...toggles[key], enabled: checked };
        currentToggles[key] = toggle;

        table.setPageIndex(0);
        setSearchText('');
        setToggles(currentToggles);
    };

    return (
        <Box>
            {Object.values(toggles).map((singleToggle) => {
                const { key, tooltip, toggleText } = singleToggle;

                return (
                    <FormControlLabel
                        control={
                            <Checkbox
                                checked={!!toggles[key] && toggles[key].enabled}
                                color="primary"
                                data-trackid={`table_${tableName}_toggleCheckbox_${key}`}
                                disabled={disabled}
                                onChange={(e) =>
                                    handleToggleChange({
                                        checked: e.target.checked,
                                        key
                                    })
                                }
                            />
                        }
                        data-trackid={`table_${tableName}_toggle_${key}`}
                        key={`table_toggle_${key}`}
                        label={
                            <Box display="inline-flex" alignItems="center">
                                <SentenceCase text={toggleText} />
                                {tooltip && (
                                    <TooltipQ
                                        text={t(`Tooltips.${tooltip}`)}
                                        size={FontSizes[1]}
                                    />
                                )}
                            </Box>
                        }
                    />
                );
            })}
        </Box>
    );
};
